import { SET_BRIDGE_LIST, SET_IS_ADMIN } from './../mutation-types'

const state = {
  bridgeList: [],
  isAdmin: false,
}

const getters = {
  getBridgeList: state => state.bridgeList,
  getIsAdmin: state => state.isAdmin,
}

const mutations = {
  [SET_BRIDGE_LIST](state, data) {
    if (data) {
      state.bridgeList = data
    } else {
      state.bridgeList = []
    }
  },
  [SET_IS_ADMIN](state, data) {
    if (data) {
      state.isAdmin = data
    } else {
      state.isAdmin = false
    }
  },
}
const actions = {
  setBridgeList({ commit }, data) {
    commit(SET_BRIDGE_LIST, data)
  },
  setIsAdmin({ commit }, data) {
    commit(SET_IS_ADMIN, data)
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
